export const gameInsightQuery = `query gameInsightsQuery($site: String!, $league: LeagueOption!,$srGameId:String,$srPlayerId:String,$srTeamId:String,$offset:Int,$insightType:InsightTypeOption)
{
  gameInsights(
    site: $site
    league: $league
    srGameId: $srGameId
    srPlayerId: $srPlayerId
    srTeamId: $srTeamId
    offset: $offset
    insightType: $insightType
  ) {
    results {
      id
      content
      relevancyIndex
      createdAt
      materials{
        id
        tabular{
          id
          title
          content
          displayType
          data{
            isHighlighted
            value
          }
        }
      }
    }
    limit
    offset
    vlId
  }
}`

export const minifiedGameInsightQuery = `query gameInsightsQuery($site: String!, $league: LeagueOption!,$srGameId:String,$srPlayerId:String,$srTeamId:String,$offset:Int,$insightType:InsightTypeOption) { gameInsights( site: $site league: $league srGameId: $srGameId srPlayerId: $srPlayerId srTeamId: $srTeamId offset: $offset insightType: $insightType ) { results { id content relevancyIndex createdAt materials{ id tabular{ id title content displayType data{ isHighlighted value } } } } limit offset vlId } }`
export const gameInsightQuerySHA = "a08d1e2b683437299463acfc030b3423fec55bd077222bc9e722a386d598975b"